// Packages
import React from "react"
import { graphql, Script } from "gatsby"

// Components
import Header from "@components/mb-about/header"
import UpperDisclosure from "@components/mb-about/upper-disclosure"
// import Video from "@components/mb-about/video"
import WhyStatement from "@components/mb-about/why-statement"
import Bio from "@components/mb-about/bio"
import CommunityInvolvement from "@components/mb-about/community-involvement"
import Resources from "@components/mb-about/resources"
import AboutBanner from "@components/mb-about/about-banner"
import Calculator from "@components/mb-about/calculator"
import Slideshow from "@components/global/slideshow"
import SEO from "@components/global/seo"

// Data
import { bankerData } from "@components/global/layout-walled-mb"
const About = props => {
  const aboutBanner = () => {
    if (
      props.data.PersonnelPage.slideshow &&
      props.data.PersonnelPage.slideshow.personalImages.length > 2
    ) {
      return false
    } else if (props.bankerData.aboutBanner) {
      return props.bankerData.aboutBanner.title
    } else {
      return "default"
    }
  }

  return (
    <>
      {props.bankerData.slug === "albertogamez" &&
      props.location.search === "?plugin" ? (
        <div
          id="widgetData"
          data-encoded="eyJzcmMiOiJodHRwczovL21ic2hpZ2h3YXkuY29tL2ltYWdlcy9mcm9udGVuZC91c2VyRGF0YS82NTE0NDA3OC1iMTI5LTQwNGQtYjcxNi1kZGQ5Yjc2MWZkNWEvaGVhZGVyL2hlYWRzaG90LnBuZz92PTc2MSIsIkxPZW1haWwiOiJhbGJlcnRvZ2FtZXpAYXRsYW50aWNiYXkuY29tIiwiaGVhZGVyRGV0YWlscyI6eyJuYW1lIjoiQWxiZXJ0byBHYW1leiIsImVtYWlsIjoiYWxiZXJ0b2dhbWV6QGF0bGFudGljYmF5LmNvbSIsIm51bWJlciI6IjI0MDk5NDc4ODMiLCJjb21wYW55IjoiQXRsYW50aWMgQmF5IE1vcnRnYWdlIEdyb3VwIiwiY29icmFuZENvZGUiOiIiLCJjb2JyYW5kRW1haWwiOiIiLCJyZXF1ZXN0Q29kZSI6Ijg3YWJmNTVlLTIzNzctNDUyNy1iODhiLTIyYTY5ZWZmZTQwZCJ9LCJzZXR0aW5ncyI6eyJjb3JwIjp0cnVlLCJlbWFpbCI6dHJ1ZSwibmFtZSI6dHJ1ZSwicGhvdG8iOnRydWUsImF2bSI6dHJ1ZSwidXJsIjoiaHR0cHM6Ly93d3cuYXRsYW50aWNiYXkuY29tL2FsYmVydG9nYW1lei8ifX0="
        ></div>
      ) : (
        <>
          <Header
            hero={
              props.data.PersonnelPage.backgroundImage
                ? props.data.PersonnelPage.backgroundImage.gatsbyImageData
                : props.data.Hero.childImageSharp.gatsbyImageData
            }
            headshot={
              props.bankerData.headshot
                ? props.bankerData.headshot.title !== "profile-default"
                  ? props.bankerData.headshot.gatsbyImageData
                  : null
                : null
            }
            logo={
              props.data.PersonnelPage.logos &&
              (props.data.PersonnelPage.logos[0].gatsbyImageData ||
                props.data.PersonnelPage.logos[0].url)
            }
            bankerData={props.bankerData}
          />
          <UpperDisclosure
            disclosure={
              props.bankerData.licensedStates.includes("TX")
                ? "mbheader-texas"
                : "mbheader"
            }
          />

          {/* 
      {props.bankerData.videoLink && <Video videoLink={props.bankerData.videoLink} />}
        */}

          {props.data.PersonnelPage.whyStatement ? (
            <WhyStatement
              whyStatement={
                props.data.PersonnelPage.whyStatement.childMarkdownRemark.html
              }
              slug={props.bankerData.slug}
              team={props.bankerData.team}
            />
          ) : (
            <Bio
              quote={
                props.bankerData.quote &&
                props.bankerData.quote.childMarkdownRemark.html
              }
              bio={
                props.data.PersonnelPage.bio &&
                props.data.PersonnelPage.bio.childMarkdownRemark.html
              }
              team={props.bankerData.theme === "team default" ? true : false}
              slug={props.bankerData.slug}
            />
          )}

          {!aboutBanner() ? (
            <Slideshow
              slides={props.data.PersonnelPage.slideshow.personalImages}
            />
          ) : (
            <AboutBanner
              title={aboutBanner()}
              image={
                props.bankerData.aboutBanner
                  ? props.bankerData.aboutBanner.gatsbyImageData
                  : props.data.Banner.childImageSharp.gatsbyImageData
              }
            />
          )}

          <Calculator licensedStates={props.bankerData.licensedStates} />
          {props.data.PersonnelPage.communitySection && (
            <CommunityInvolvement
              copy={
                props.data.PersonnelPage.communitySection &&
                props.data.PersonnelPage.communitySection.groups[0].copy
              }
              slideshow={
                props.data.PersonnelPage.communitySection.groups[0].images
              }
            />
          )}
          {props.data.PersonnelPage.resourcesSection && (
            <Resources
              copy={
                props.data.PersonnelPage.resourcesSection &&
                props.data.PersonnelPage.resourcesSection.groups[0].copy.body
                  .childMarkdownRemark.html
              }
              resource={
                props.data.PersonnelPage.resourcesSection.groups[0].links[0]
              }
            />
          )}
        </>
      )}
    </>
  )
}

// Meta tags
export const Head = props => {
  const excludeRebeliQWidgetMBs = ["allycain", "sarachandler"]
  const description =
    bankerData.slug === "mitchpayne"
      ? `Mitch Payne, Atlantic Bay Mortgage Group® | Living in and serving the 30A markets. I'm here to assist you as you buy, refinance, or build the home of your dreams.`
      : `${bankerData.name}, Atlantic Bay Mortgage Group® | ${bankerData.city}, ${bankerData.state} ${bankerData.zip} is here to assist you as you buy, refinance, or build the home of your dreams.`
  const tile =
    bankerData.slug === "mitchpayne"
      ? `Mitch Payne | Atlantic Bay Mortgage Group® | Living in and serving the 30A markets`
      : `${bankerData.name} | Atlantic Bay Mortgage Group® | ${bankerData.city}, ${bankerData.state} ${bankerData.zip}`
  return (
    <SEO
      description={description}
      title={tile}
      ogImage={bankerData.ogImage && "https:" + bankerData.ogImage.file.url}
      slug={bankerData.slug}
    >
      {bankerData.slug === "albertogamez" && (
        <Script
          src="https://mbshighway.com/scripts/plugins/widgetRender.js"
          type="text/javascript"
        />
      )}
      {/* RebeliQ widget */}
      {!excludeRebeliQWidgetMBs.includes(bankerData.slug) && (
        <Script
          src="https://embed.clix.ly/entatlantic96cd00dd1faff4821ca072e9.js"
          type="text/javascript"
        />
      )}
    </SEO>
  )
}

export default About

export const query = graphql`
  query ($slug: String!) {
    Hero: file(relativePath: { regex: "/mb-about/hero-default.jpg/" }) {
      childImageSharp {
        gatsbyImageData(quality: 100, layout: FULL_WIDTH)
      }
    }
    Banner: file(relativePath: { regex: "/mb-about/default-banner.jpg/" }) {
      childImageSharp {
        gatsbyImageData(quality: 100, layout: FULL_WIDTH)
      }
    }
    PersonnelPage: contentfulPersonnelPage(slug: { eq: $slug }) {
      whyStatement {
        childMarkdownRemark {
          html
        }
      }
      bio {
        childMarkdownRemark {
          html
        }
      }
      backgroundImage {
        title
        gatsbyImageData(quality: 100, layout: FULL_WIDTH)
      }
      communitySection {
        groups {
          ...Group
          container {
            ...Group
          }
        }
      }
      logos {
        gatsbyImageData
        url
      }
      resourcesSection {
        groups {
          ...Group
          container {
            ...Group
          }
        }
      }
      slideshow {
        personalImages {
          id
          description
          gatsbyImageData(width: 480, quality: 90)
        }
      }
    }
  }
`
